import { Injectable } from '@angular/core';
import { DbService } from './db.service';
import { AuthService } from './auth.service';
import * as dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private db: DbService, private auth: AuthService) {}

  displayMethod(paymentMethod: 'card' | 'account' | 'naver' | 'kakao' | 'toss') {
    const mapping = {
      card: '신용카드',
      account: '무통장입금',
      naver: 'PG결제 (Npay)',
      kakao: 'PG결제 (Kakaopay)',
      toss: 'PG결제 (Tosspay)',
    };

    return mapping[paymentMethod];
  }

  displayStatus(payStatus: 'wait' | 'paid' | 'pending' | 'refund' | 'accountCancel' | 'fundpending' | 'fundRefund') {
    const mapping = {
      wait: '입금대기',
      paid: '결제완료',
      pending: '결제취소(환불예정)',
      refund: '결제취소(환불완료)',
      accountCancel: '입금미확인취소',
      fundpending: '펀딩실패(환불예정)',
      fundRefund: '펀딩실패(환불완료)',
    };

    return mapping[payStatus];
  }

  // 입금에 대한 내용을 가져오기
  depositDate(date) {
    return dayjs(date).add(3, 'day').format('(무통장입금확인 : YYYY.MM.DD HH:mm)');
  }
}
